import clsx from 'clsx'
import React, { useMemo } from 'react'
import { useTranslation } from '../../i18n/useTranslation'
import { Offer } from '../../interface/offerInterface'
import { CountdownTimer } from '../CountdownTimer'

interface OfferDetailsProps {
  offer: Offer
  quantity: number
}

export const OfferDetails: React.FC<OfferDetailsProps> = ({
  offer,
  quantity
}) => {
  const { offerCardTranslations } = useTranslation()

  const expiredAt = useMemo(
    () => (offer.endDate ? new Date(offer.endDate) : undefined),
    [offer]
  )
  const bonus = useMemo(
    () =>
      offer.bonus
        ? `${offerCardTranslations.bonus} ${offer.bonus}%`
        : undefined,
    [offer, offerCardTranslations]
  )
  const itemQuantitiy = useMemo(() => {
    const { items } = offer.sku
    const firstKey = Object.keys(items)[0]

    if (!firstKey) {
      return undefined
    }

    return items[firstKey as keyof Offer['sku']['items']]
  }, [offer])

  return (
    <div
      className={clsx(
        'relative flex max-w-[402px] flex-1 justify-center rounded-lg border-[1.5px] border-black',
        offer.sku.displayOfferType === 'grand' ? 'items-end' : 'items-center'
      )}
      style={{
        backgroundImage: `url(${offer.sku.backgroundUrl})`,
        backgroundSize: 'cover'
      }}
    >
      {bonus && (
        <div className='font-border poppins-lg absolute left-[-14px] top-[-10px] z-10 flex h-[40.5px] w-[131.41px] items-center bg-[url(/assets/bonus-flag.png)] bg-cover bg-no-repeat pl-4 md:-top-5 md:left-[-25px] md:h-[70px] md:w-[240px] md:pl-7'>
          {bonus}
        </div>
      )}
      {expiredAt && (
        <div className='absolute inset-x-0 top-0 flex items-center justify-end rounded-t-md bg-[#0E122C66] px-3 py-1 [clip-path:polygon(0_0,100%_0%,100%_100%,0%_80%)]'>
          <span className='font-border poppins-md uppercase'>
            {offerCardTranslations.expiresIn}{' '}
            <CountdownTimer targetDate={expiredAt} />
          </span>
        </div>
      )}
      <div className='absolute right-5 top-12 flex'>
        {itemQuantitiy && (
          <div className='font-border poppins-3xl rounded-[10px] bg-[#0E122C33] px-[14px] py-[5px]'>
            {(itemQuantitiy * quantity).toLocaleString()}
          </div>
        )}
      </div>
      <img
        src={offer.sku.imageUrl}
        alt='offer-item'
      />
    </div>
  )
}
